
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discord",
      function () {
        return require("private-next-pages/discord.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discord"])
      });
    }
  